export const ENV_TESTNET = 'testnet' as const;
export const ENV_PRODUCTION = 'production' as const;
